import { Button, Modal, Paper, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { isMobile } from "react-device-detect";

export default function HeadsetModal({
  open,
  setOpen,
  onSubmit,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSubmit: (nickname: string) => void;
}) {
  const [nickname, setNickname] = useState<string>("");

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Paper
        sx={{
          width: "30%",
          height: isMobile ? "40%" : "30%",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
          backgroundColor: "#6f7376",
          overflow: "auto",
        }}
      >
        <Typography variant="h5" color="secondary" fontWeight={"bold"}>
          Name this headset?
        </Typography>
        <TextField
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          label="Headset Nickname"
          variant="outlined"
          color="secondary"
          defaultValue={"My Headset"}
          sx={{ marginTop: 2, width: "80%" }}
        />
        <div style={{ display: "flex", flexDirection: "row", gap: "1em" }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ marginTop: 2 }}
            onClick={() => {
              onSubmit("noname");
              setOpen(false);
            }}
          >
            No Thanks
          </Button>
          <Button
            variant="contained"
            color="secondary"
            sx={{ marginTop: 2 }}
            onClick={() => {
              onSubmit(nickname);
              setOpen(false);
            }}
          >
            Submit
          </Button>
        </div>
      </Paper>
    </Modal>
  );
}
